import CreateIcon from "@mui/icons-material/Create"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useMemo } from "react"

import { PRIMARY } from "@constants/colors"
import getPercent from "@utils/functions/get_percent"

import { useCustomerPageContext } from "@contexts/customer"
import styles from "./styles"

export default function Usage() {
  const { translate, currentCustomer: customer } = useCustomerPageContext()

  const addOnUser = useMemo(() => {
    return customer?.package?.addOns.find((addOn) => addOn.name === "User")
  }, [customer?.package?.addOns])

  const toggleIsRemoveAdditionalUserSeatModalOpen = () => {
    console.log("Toggle Remove Additional User Seat Modal")
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Typography>{translate("usage")}</Typography>
      <Stack sx={styles.usageConatiner}>
        <UsageContent
          title={translate("user_seats")}
          value={customer?.package?.usages?.cPerson ?? 0}
          maxValue={
            (customer?.package?.limits?.cPerson || 0) +
            (addOnUser?.quantity || 0)
          }
          icon={
            <CreateIcon
              onClick={toggleIsRemoveAdditionalUserSeatModalOpen}
              sx={{
                color: "#868686",
                cursor: "pointer",
                transition: "color 0.3s",
                ":hover": { color: PRIMARY },
                display:
                  customer?.package?.usages?.cPerson ===
                  customer?.package?.limits?.cPerson
                    ? "none"
                    : "block"
              }}
            />
          }
        />
        <UsageContent
          title={translate("active_customers")}
          value={customer?.package?.usages?.person || 0}
          maxValue={customer?.package?.limits?.person || 0}
        />
        <UsageContent
          title={translate("account_balance")}
          value={customer?.package?.accountBalance || 0}
        />
      </Stack>
      {/* <RemoveAdditionalUserSeats /> */}
    </Box>
  )
}
function UsageContent({
  title,
  value,
  maxValue,
  icon
}: {
  title: string
  value: number
  maxValue?: number
  icon?: React.ReactNode
}) {
  const { translate } = useCustomerPageContext()
  const formattedValue = useMemo(() => {
    return title === translate("account_balance")
      ? `$${value.toFixed(2)}`
      : value
  }, [title, translate, value])

  const formattedMaxValue = useMemo(() => {
    return title === translate("account_balance")
      ? `$${maxValue?.toFixed(2)}`
      : maxValue
  }, [title, translate, maxValue])

  const percentage = useMemo(() => {
    if (maxValue === undefined && value > 0) {
      return 100
    }
    if (maxValue === undefined) {
      return 0
    }
    return maxValue === 0
      ? value === 0
        ? 0
        : 100
      : getPercent(value, maxValue)
  }, [value, maxValue])
  return (
    <Stack gap={1}>
      <Stack justifyContent={"space-between"} direction={"row"}>
        <Stack direction={"row"} gap={1}>
          <Typography>{title}</Typography>
          {icon}
        </Stack>
        <Stack direction={"row"} gap={0.35}>
          <Typography sx={{ color: "gray" }}>{formattedValue}</Typography>
          {maxValue && (
            <>
              <Typography>/</Typography>
              <Typography>{formattedMaxValue}</Typography>
            </>
          )}
        </Stack>
      </Stack>
      <Box sx={{ position: "relative" }}>
        <Box sx={styles.barBase} />
        <Box
          sx={styles.barActive(
            percentage,
            title === translate("account_balance")
          )}
        />
      </Box>
    </Stack>
  )
}
